import { Navigate, useOutletContext, useParams } from 'react-router-dom'
import { CategoryAttachments } from '@/components/CategoryAttachments'
import { DeviceList } from '@/components/DeviceList'
import { PageCanvas } from '@/components/PageCanvas'

function isPoliciesOrRegistersPage(category) {
  if (!category) return false
  return (
    category.slug === 'policies' ||
    category.slug === 'registers' ||
    category.parent_slug === 'policies' ||
    category.parent_slug === 'registers'
  )
}

function pageTitle(category, customer) {
  const base = category?.title || ''
  if (!isPoliciesOrRegistersPage(category) || !customer?.name) return base
  const suffix = ` (${customer.name})`
  if (base.endsWith(suffix)) return base
  return `${base}${suffix}`
}

export function CategoryPage() {
  const { slug } = useParams()
  const {
    customer,
    categories,
    setCategories,
    canEdit,
    toggleHidden,
    setCustomer,
  } = useOutletContext()
  const category = categories.find((c) => c.slug === slug)

  if (!category) {
    const first = categories[0]
    if (first) {
      return <Navigate to={`/customers/${customer.id}/${first.slug}`} replace />
    }
    return (
      <div className="rounded-xl border border-slate-200 bg-white/90 p-8 shadow-sm">
        <p className="text-brand-muted">No categories available.</p>
      </div>
    )
  }

  function onCategoryUpdated(updated) {
    setCategories((prev) =>
      prev.map((c) => (c.slug === updated.slug ? { ...c, ...updated } : c)),
    )
  }

  const heading = pageTitle(category, customer)

  return (
    <div className="rounded-xl border border-slate-200 bg-white/90 p-6 shadow-sm sm:p-8">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <h1 className="font-display text-3xl tracking-tight text-brand">{heading}</h1>
          {category.kind === 'devices' && (
            <p className="mt-2 text-sm text-brand-muted">
              Live list from Bekat Dash
              {category.slug === 'workstations'
                ? ' — Folder shows Workstation or Laptop.'
                : '.'}
            </p>
          )}
        </div>
        {canEdit && (
          <button
            type="button"
            onClick={() => toggleHidden(category.slug, category.hidden_from_customer)}
            className="shrink-0 rounded-md border border-slate-300 px-3 py-2 text-sm font-medium hover:bg-slate-50"
          >
            {category.hidden_from_customer
              ? 'Show page to customer'
              : 'Hide page from customer'}
          </button>
        )}
      </div>

      <CategoryAttachments
        customerId={customer.id}
        categorySlug={category.slug}
        canEdit={canEdit}
      />

      {category.kind === 'devices' ? (
        <DeviceList
          customerId={customer.id}
          category={category}
          customer={customer}
          canEdit={canEdit}
          onCustomerUpdated={setCustomer}
        />
      ) : (
        <PageCanvas
          customerId={customer.id}
          category={category}
          canEdit={canEdit}
          onCategoryUpdated={onCategoryUpdated}
        />
      )}
    </div>
  )
}
